module.exports = {
      id: "socialshare-usage",
      viewBox: "0 0 23.63 25.957",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#socialshare",
      toString: function () {
        return this.url;
      }
    }